import { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';
import i18n from '../../i18n';

function t(key: string): string {
  return i18n.t(key);
}

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  retryKey: number;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, retryKey: 0 };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, retryKey: 0 };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleReload = () => {
    this.setState((prev) => ({ hasError: false, error: null, retryKey: prev.retryKey + 1 }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <span className="error-boundary__icon">⚠️</span>
          <h2 className="error-boundary__title">{t('errorBoundary.title')}</h2>
          <p className="error-boundary__text">
            {this.state.error?.message || t('errorBoundary.message')}
          </p>
          <button className="btn btn--primary" onClick={this.handleReload}>
            {t('errorBoundary.retry')}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
